import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  sessions: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
  selectedSessionYear: null,
};

const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {
    fetchSessionStart(state) {
      state.loading = false;
      state.error = null;
    },
    fetchSessionSuccess(state, action) {
      state.sessions = action.payload.sessions;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchSessionFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addSessionStart(state) {
      state.loading = true;
      state.error = null;
    },
    addSessionSuccess(state, action) {
      state.loading = false;
      state.sessions.unshift(action.payload);
      state.error = null;
    },
    addSessionFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    setSelectedSessionYear(state, action) {
      state.selectedSessionYear = action.payload;
    },

    deleteSessionStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteSessionSuccess(state, action) {
      state.loading = false;
      state.sessions = state.sessions.filter(
        (session) => session.id !== action.payload
      );
      state.error = null;
    },
    deleteSessionFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editSessionStart(state) {
      state.loading = true;
      state.error = null;
    },
    editSessionSuccess(state, action) {
      state.loading = false;
      const updatedSession = action.payload;
      const index = state.sessions.findIndex(
        (session) => session.id === updatedSession.id
      );
      if (index !== -1) {
        state.sessions[index] = updatedSession;
      }
      state.error = null;
    },
    editSessionFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    updateSessionStatusStart(state) {
      state.loading = false;
      state.error = null;
    },
    updateSessionStatusSuccess(state, action) {
      state.loading = false;
      const updatedSessionStatus = action.payload;
      const index = state.sessions.findIndex(
        (session) => session.id === updatedSessionStatus.id
      );
      if (index !== -1) {
        state.sessions[index] = updatedSessionStatus;
      }
    },
    updateSessionStatusFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    // getCategoryByIdStart(state) {
    //   state.loading = false;
    //   state.error = null;
    //   state.selectedCategory = null;
    // },
    // getCategoryByIdSuccess(state, action) {
    //   state.loading = false;
    //   state.selectedCategory = action.payload;
    //   state.error = null;
    // },
    // getCategoryByIdFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    resetSession(state) {
      state.categories = [];
      state.selectedSessionYear = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchSessionStart,
  fetchSessionSuccess,
  fetchSessionFailure,
  addSessionStart,
  addSessionSuccess,
  addSessionFailure,
  deleteSessionStart,
  deleteSessionSuccess,
  deleteSessionFailure,
  editSessionStart,
  editSessionSuccess,
  editSessionFailure,
  updateSessionStatusStart,
  updateSessionStatusSuccess,
  updateSessionStatusFailure,
  setSelectedSessionYear,
  //   getCategoryByIdFailure,
  //   getCategoryByIdStart,
  //   getCategoryByIdSuccess,
  resetSession,
} = sessionsSlice.actions;

export default sessionsSlice.reducer;
